import { Controller } from 'stimulus'
import $ from 'jquery'

export default class extends Controller {
  static targets = ['title', 'input', 'error']

  connect() {
    this.open = this.open.bind(this)
    this.closed = this.closed.bind(this)
    window.addEventListener('prompt-modal:open', this.open)
    this.element.addEventListener('modal:closed', this.closed)
  }

  disconnect() {
    window.removeEventListener('prompt-modal:open', this.open)
    this.element.removeEventListener('modal:closed', this.closed)
  }

  open(event) {
    this.trigger = event.detail.trigger || null
    this.callback = event.detail.callback || null
    this.submitted = false
    this.prompt = event.detail.message || this.readData('prompt') || ''
    this.maxlen = event.detail.maxlen || this.readData('maxlen')
    this.match = event.detail.match || this.readData('match')
    this.matchMsg = event.detail.matchMsg || this.readData('matchMsg') || 'Not in the right format'
    this.attr = event.detail.attr || this.readData('attr') || 'value'
    this.ajaxUrl = this.readData('ajaxUrl') || this.trigger?.getAttribute('href')
    this.ajaxMethod = this.readData('ajaxMethod') || 'POST'

    this.titleTarget.textContent = this.prompt
    this.inputTarget.value = event.detail.value || this.readData('value') || ''
    this.inputTarget.removeAttribute('maxlength')
    if (this.maxlen) this.inputTarget.setAttribute('maxlength', this.maxlen)
    this.hideError()

    this.element.dispatchEvent(new CustomEvent('modal:show'))
    setTimeout(() => this.inputTarget.focus(), 50)
  }

  submit(event) {
    event.preventDefault()

    const value = this.inputTarget.value
    if (value === '') {
      this.showError("Can't be blank")
      return
    }

    if (!this.valid(value)) return

    if (this.callback) {
      this.submitted = true
      this.callback(value)
      this.inputTarget.value = ''
      this.element.dispatchEvent(new CustomEvent('modal:hide'))
      return
    }

    if (!this.ajaxUrl) {
      this.showError('No action configured.')
      return
    }

    const $trigger = $(this.trigger)
    const shouldDisable =
      $.rails?.disableFormElement && !!$trigger.data('disable-with')

    this.submitted = true
    $trigger.data('value', value)
    shouldDisable && $.rails.disableFormElement($trigger)

    $.sajax({
      url: this.ajaxUrl,
      type: this.ajaxMethod,
      data: { [this.attr]: value },
      success: () => {
        this.inputTarget.value = ''
        this.element.dispatchEvent(new CustomEvent('modal:hide'))
      },
      error: () => {
        this.submitted = false
        this.showError('Request failed. Please try again.')
      },
      complete: function () {
        shouldDisable && $.rails.enableFormElement($trigger)
      },
    })
  }

  closed() {
    if (!this.submitted) this.reenableDisableOnClickTarget()
  }

  readData(name) {
    if (!this.trigger) return null
    const promptModalSuffix = `${name[0].toUpperCase()}${name.slice(1)}`
    const promptModalName = `promptModal${promptModalSuffix}`
    return this.trigger.dataset[promptModalName] ?? this.trigger.dataset[name]
  }

  valid(value) {
    if (this.maxlen && value.length > Number(this.maxlen)) {
      this.showError(`Too long. Maximum length is ${this.maxlen}`)
      return false
    }

    if (this.match && !value.match(new RegExp(this.match))) {
      this.showError(this.matchMsg)
      return false
    }

    return true
  }

  showError(message) {
    this.errorTarget.textContent = message
    this.errorTarget.classList.remove('hidden')
  }

  hideError() {
    this.errorTarget.textContent = ''
    this.errorTarget.classList.add('hidden')
  }

  reenableDisableOnClickTarget() {
    if (!this.trigger) return
    const behavior = $(this.trigger).data('behavior')
    if (typeof behavior === 'string' && behavior.includes('disable-on-click')) {
      $(this.trigger).removeClass('disabled').attr('disabled', false)
    }
  }
}
